import React from 'react'

import logo from '../../assets/images/logo_2_nb.png'

//CSS
import './Header.css'

//MUI
import { Box, Button, Container, Drawer, IconButton, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

//Router dom
import { Link } from 'react-router-dom'

const Sidebar = ({ open, setOpen }) => {

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <Drawer
            open={open}
            onClose={handleClose}
            anchor='bottom'
            PaperProps={{
                sx: { height: '100%' },
            }}
            transitionDuration={{ enter: 600, exit: 200 }}
        >
            <>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', m: 2.5 }}>
                    <IconButton onClick={handleClose} size='large' sx={{ color: '#797d7f' }}>
                        <CloseIcon fontSize='inherit' />
                    </IconButton>
                </Box>

                <Container maxWidth='xl' sx={{ my: 3 }}>
                    <Stack spacing={2}>
                        <Button sx={{ fontSize: '24px', color: '#797d7f', fontWeight: '800' }} component={Link} to="/" onClick={handleClose}>Inicio</Button>
                        <Button sx={{ fontSize: '24px', color: '#797d7f', fontWeight: '800' }} component={Link} to="/nosotros" onClick={handleClose}>Nosotros</Button>
                        <Button sx={{ fontSize: '24px', color: '#797d7f', fontWeight: '800' }} component={Link} to="/servicios" onClick={handleClose}>Servicios</Button>
                        {/* <Button sx={{ fontSize: '24px', color: '#797d7f', fontWeight: '800' }} component={Link} to="/certificaciones" onClick={handleClose}>Certificaciones</Button> */}
                        <Button sx={{ fontSize: '24px', color: '#797d7f', fontWeight: '800' }} component={Link} to="/contacto" onClick={handleClose}>Contacto</Button>
                    </Stack>
                </Container>

                <Box sx={{ position: 'absolute', bottom: '25px', left: '50%', transform: 'translate(-50%, -50%)', margin: '0 auto' }}>
                    <img src={logo} alt='F+H' className='sidebar_logo' />
                </Box>
            </>
        </Drawer>
    )
}

export default Sidebar